/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalImageMetadataPoseCenter
 */
export interface ExternalImageMetadataPoseCenter {
    /**
     * 
     * @type {number}
     * @memberof ExternalImageMetadataPoseCenter
     */
    x: number;
    /**
     * 
     * @type {number}
     * @memberof ExternalImageMetadataPoseCenter
     */
    y: number;
    /**
     * 
     * @type {number}
     * @memberof ExternalImageMetadataPoseCenter
     */
    z: number;
}

/**
 * Check if a given object implements the ExternalImageMetadataPoseCenter interface.
 */
export function instanceOfExternalImageMetadataPoseCenter(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "x" in value;
    isInstance = isInstance && "y" in value;
    isInstance = isInstance && "z" in value;

    return isInstance;
}

export function ExternalImageMetadataPoseCenterFromJSON(json: any): ExternalImageMetadataPoseCenter {
    return ExternalImageMetadataPoseCenterFromJSONTyped(json, false);
}

export function ExternalImageMetadataPoseCenterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalImageMetadataPoseCenter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'x': json['x'],
        'y': json['y'],
        'z': json['z'],
    };
}

export function ExternalImageMetadataPoseCenterToJSON(value?: ExternalImageMetadataPoseCenter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'x': value.x,
        'y': value.y,
        'z': value.z,
    };
}

